import * as React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt, faSave, faThumbtack, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { successToastr } from "../../../HelperMethods";
import { Dialog } from "@progress/kendo-react-dialogs";
import CreateNewReportSearch from "./CreateNewReportSearch";
import DeleteConfirmationModal from "../../Shared/Search/DeleteConfirmationModal";
import { DELETE_REPORT_SEARCH_CONFIRMATION_MSG, REPORT_SEARCH_DELETED_SUCCESS_MSG } from "../../Shared/AppMessages";
import { DeleteReportSearch, PatchReportSearch } from "../Services/DataServices";

export interface RptSaveSearchProps {
  disableSearch?: any;
  reportName: any;
  reportId: any;
  viewerRef: any;
  selectSearch: Function;
  getSavedReportSearches: Function;
  savedReportSearches: any;
}

export interface ReportSavedSearchState {
  suggestedData: any;
  defaultSelected: string;
  deleteConfirmationModal?: boolean
  reportSearchId?: any;
  searchName?: any;
  savedReportSearches?: any;
  disableSaveFilter?: any;
  showAddNewReportModal?: any;
  filterName?: any;
  isPinned?: any;
}
class ReportSavedSearch extends React.Component<RptSaveSearchProps, ReportSavedSearchState> {
  constructor(props: RptSaveSearchProps) {
    super(props);
    this.state = {
      suggestedData: [],
      defaultSelected: "All",
      disableSaveFilter: false,
      isPinned: false
    };
  }

  componentDidMount() {
    this.updateStateData();
  }

  pinnedValue = (data, newSavedSearch) => {
    newSavedSearch == undefined ? data.map((item) => {
      return item.pinned ? this.setState({ defaultSelected: item.name }) : null;
    }) : data.map((item) => {
      return item.reportSearchId === newSavedSearch ? this.setState({ defaultSelected: item.name }) : null;
    })
  };


  defaultSearch = () => {
    this.setState({ defaultSelected: "All" });
  };

  itemRender = (li) => {
    var ifpinned;
    var reportSearchId;
    let searchName;
    let data = this.getSelectedData(li.props.children[0].props.children);
    if (li.props.children[0].props.children !== "All") {
      if (data[0].pinned) {
        ifpinned = true;
      } else {
        ifpinned = false;
      }
      reportSearchId = data[0].reportSearchId;
      searchName = data[0].name;
    }
    const itemChildren =
      li.props.children[0].props.children === "All" ? (
        <span className="col-12" onClick={this.defaultSearch}>
          All
        </span>
      ) : (
        <div className="row mr-0 ml-0 w-100">
          {" "}
          <div className="col pl-0">
            <span
              className="whiteHover pinColor"
              color={ifpinned}
              onClick={() =>
                data[0].pinned
                  ? this.pinUnpinSearch(reportSearchId, false)
                  : this.pinUnpinSearch(reportSearchId, true)
              }
            >
              <FontAwesomeIcon
                icon={faThumbtack}
                className={ifpinned ? "black_rotate" : "gray_rotate"}
              />
            </span>
            <span className="pl-2 whiteHover">{li.props.children[0].props.children} </span>
          </div>
          <div className="col-auto d-flex justify-content-between pr-0">
          <span
              onClick={() => this.EditSavedSearch(reportSearchId)}
              className="text-primary whiteHover"
            >
              <FontAwesomeIcon icon={faPencilAlt} />
            </span>
            <span
              onClick={() => this.setState({ reportSearchId: reportSearchId, searchName: searchName, deleteConfirmationModal: true })}
              className="text-primary whiteHover ml-3"
            >
              <FontAwesomeIcon icon={faTrashAlt} />
            </span>
          </div>
        </div>
      );
    return React.cloneElement(li, li.props, itemChildren);
  };

  updateStateData = () => {
    this.setState({ suggestedData: this.props.savedReportSearches });
  };

  EditSavedSearch = (id) => {
    let data = this.getSelectedData(id);
    setTimeout(() => this.props.selectSearch(data, true), 500);
  };

  selectedSearchOption = (e) => {
    if (e.target.value === "All") {
      this.setState({ reportSearchId: null, isPinned: false });
      this.props.selectSearch([],true);
    } else {
      let data = this.getSelectedData(e.target.value);
      if (data.length > 0) {
        this.setState({ reportSearchId: data[0].reportSearchId, defaultSelected: data[0].name, isPinned: data[0].pinned });
        this.props.selectSearch(data, true);
      }
    }
  };

  setSelectedData = (selectedData) => {
    if (selectedData.length > 0 && selectedData[0] != undefined && selectedData[0] != null) {
      this.setState({ reportSearchId: selectedData[0].reportSearchId, filterName: selectedData[0].name, isPinned: selectedData[0].pinned });
    } else {
      this.setState({ reportSearchId: null, filterName: '', isPinned: false });
    }
  }

  deleteReportSavedSearch = (id) => {
    let reportSearchId = id;
    let dataAfterDelete = this.props.savedReportSearches.filter(
      (i) => i.reportSearchId !== reportSearchId
    );
    DeleteReportSearch(reportSearchId)
      .then(() => {
        successToastr(REPORT_SEARCH_DELETED_SUCCESS_MSG);
        this.setState({
          suggestedData: dataAfterDelete,
          defaultSelected: "All",
        });
      })
      .then(() => this.defaultSearch())
      .then(() => this.props.getSavedReportSearches(this.props.reportName)).then(() => this.setState({ deleteConfirmationModal: false }));
  };

  getSelectedData = (dataName) => {
    let data = this.props.savedReportSearches.filter((i) =>
      i.name === dataName || i.reportSearchId === dataName ? i : null
    );
    return data;
  };

  pinUnpinSearch = (id, ifpinned) => {
    let data = this.getSelectedData(id);
    let searchId = id;
    PatchReportSearch(searchId, ifpinned)
      .then(() => {
        this.props.getSavedReportSearches(this.props.reportName);
      })
      .then(() =>
        ifpinned
          ? (this.setState({ defaultSelected: data[0].name }))
          : this.defaultSearch()
      );
  };

  AddNewReportModal = () => {
    this.setState({ showAddNewReportModal: true })
  }

  showCreateModal = () => {
    this.setState({ showAddNewReportModal: false });
  }

  render() {
    const { disableSearch } = this.props;
    const { suggestedData } = this.state;
    let savedSearchesData = suggestedData.map((i) => i.name);
    savedSearchesData.unshift("All");
    return (<>
      <button type="submit" className="btn button button-bg mr-2 shadow mb-2 mb-xl-0"
        onClick={() => this.setState({ showAddNewReportModal: true })}
        disabled={disableSearch}>
        <FontAwesomeIcon icon={faSave} className={"mr-1"} /> Save Filter
      </button>
      <div className="text-right ml-3 advancesearch_reporting">
        <div className="row d-flex justify-content-end mr-0 remove-ml-forMobile">
          <div className="col-12 pl-0 pr-0" id="remove-shadow">
            <DropDownList
              data={savedSearchesData}
              itemRender={this.itemRender}
              className="btn font-style-italic advancesearch_heighty w-100 rounded-right buttonSaveSearch Advacne_buttonSaveSearch p-0 d-flex align-items-center"
              value={this.state.defaultSelected}
              onFocus={this.updateStateData}
              onChange={this.selectedSearchOption}
              disabled={disableSearch}
            />
          </div>
        </div>
      </div>
      {this.state.showAddNewReportModal && (
        <div id="add-ReportingFilter ">
          <Dialog className="col-12 For-all-responsive-height">
            {(<CreateNewReportSearch
              onCloseModal={() => this.setState({ showAddNewReportModal: false })}
              onOpenModal={() => this.setState({ showAddNewReportModal: true })}
              getSavedReportSearches={this.props.getSavedReportSearches}
              reportName={this.props.reportName}
              reportId={this.props.reportId}
              filterName={this.state.filterName}
              isPinned={this.state.isPinned}
              reportSearchId={this.state.reportSearchId}
              showCreateModal={this.showCreateModal}
            />)}
          </Dialog>
        </div>
      )}
      {this.state.deleteConfirmationModal ? (
        <DeleteConfirmationModal
          message={DELETE_REPORT_SEARCH_CONFIRMATION_MSG(this.state.searchName)
          }
          showModal={this.state.deleteConfirmationModal}
          handleYes={(props) =>
            this.deleteReportSavedSearch(
              this.state.reportSearchId
            )
          }
          handleNo={() => {
            this.setState({ deleteConfirmationModal: false });
          }}
          radioSelection={false}
        />
      ) : null}
    </>);
  }
}
export default ReportSavedSearch;